import {Params} from '@angular/router';

// import {PropsMapping} from '@shared/interfaces';
import {Model} from './model';
import {DrawingModel} from './drawing.model';
import {TeamModel} from './team.model';

// const propsMapping: PropsMapping = {
const propsMapping: Params = {
  tournamentCategoryId: 'tournamentCategoryId',
  eventId: 'eventId',
  drawingId: 'drawingId',
  group: 'group',
  rank: 'rank',
  matchesFor: 'matchesFor',
  matchesAgainst: 'matchesAgainst',
  setsFor: 'setsFor',
  setsAgainst: 'setsAgainst',
  gamesFor: 'gamesFor',
  gamesAgainst: 'gamesAgainst',
  isSeed: 'isSeed',

  isClassified: 'isClassified',
  drawing: 'drawing',
};

export class GroupRankingModel extends Model {
  tournamentCategoryId!: number;
  eventId!: number;
  drawingId!: number;
  group!: number;
  rank!: number;
  matchesFor!: number;
  matchesAgainst!: number;
  setsFor!: number;
  setsAgainst!: number;
  gamesFor!: number;
  gamesAgainst!: number;
  isSeed!: boolean;

  isClassified!: boolean;
  matchesPlayed?: number;
  drawing?: DrawingModel;

  get avatarImg(): string {
    if (!this.drawing?.team) {
      // Imagen por defecto
      return 'player.png';
    }

    const team: TeamModel = this.drawing.team;

    if (team.teamAvatar) {
      return String((team.teamAvatar % 30) + 1) + '.png';
    }

    if (team.playerAvatar) {
      return String((team.playerAvatar % 30) + 1) + '.png';
    }

    if (this.drawing?.team?.name) {
      // Imagen por defecto del equipo
      return 'team.png';
    }

    // Imagen por defecto del jugador
    // @TODO: validar el genero del jugador para mostrar un avatar femenino
    // o masculino
    return 'player.png';
  }

  static getInstance(data: Params): GroupRankingModel {
    const model = new GroupRankingModel();
    for (const prop in propsMapping) {
      if (
        data[propsMapping[prop]] === undefined ||
        data[propsMapping[prop]] === null
      ) {
        continue;
      }

      if (prop === 'drawing') {
        (model as Params)[prop] = DrawingModel.getInstance(data[propsMapping[prop]]);
      } else {
        (model as Params)[prop] = data[propsMapping[prop]];
      }
    }

    model.matchesPlayed = model.matchesFor + model.matchesAgainst;

    return model;
  }

  // static search(
  //   apiService: ApiService,
  //   tournamentId: number,
  //   urlParams?: HttpParams
  // ): Observable<ListState<GroupRankingModel>> {
  //   return apiService
  //     .get(`tournaments/${tournamentId}/ranking/groups`, urlParams)
  //     .pipe(
  //       map((data: Params): ListState<GroupRankingModel> => {
  //         const list: GroupRankingModel[] = data['data'].map((item: Params): GroupRankingModel =>
  //           GroupRankingModel.getInstance(item)
  //         );
  //
  //         // const paginator: Paginator = {
  //         //   total: data.total,
  //         //   perPage: data.perPage,
  //         //   currentPage: data.currentPage,
  //         //   lastPage: data.lastPage,
  //         //   // from: data.from,
  //         //   // to: data.to
  //         // };
  //
  //         // return {list, paginator};
  //         return {list};
  //       })
  //     );
  // }
}
